var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaytoday(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#1A1464"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 33.5994C13.32 33.5994 12.9 33.4194 12.54 33.0594C12.18 32.6994 12 32.2794 12 31.7994V16.1994C12 15.7194 12.18 15.2994 12.54 14.9394C12.9 14.5794 13.32 14.3994 13.8 14.3994H34.2C34.68 14.3994 35.1 14.5794 35.46 14.9394C35.82 15.2994 36 15.7194 36 16.1994V31.7994C36 32.2794 35.82 32.6994 35.46 33.0594C35.1 33.4194 34.68 33.5994 34.2 33.5994H13.8ZM13.8 23.3394H34.2V19.4694H13.8V23.3394Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaytoday);
export default __webpack_public_path__ + "static/media/paytoday.be2b96827f943d2723514c27ee393616.svg";
export { ForwardRef as ReactComponent };